import { render, staticRenderFns } from "./SlotModal.vue?vue&type=template&id=efb5e4d4&scoped=true"
import script from "./SlotModal.vue?vue&type=script&lang=js"
export * from "./SlotModal.vue?vue&type=script&lang=js"
import style0 from "./SlotModal.vue?vue&type=style&index=0&id=efb5e4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb5e4d4",
  null
  
)

export default component.exports